
////////////////////////////////////
// M064 progress stage

function initProgressStage(){
    
	if($(".progressStage").length > 0){
		
		$(".progressStage").each(function(){

			$(this).attr("data-autoplay", "true");
			
			var $slider = $(this).find(".progressStage__slider");
			var $blocks = $(this).find(".progressStage__blocks");

			$slider.slick({
				infinite: true,
				draggable: false,
				slidesToShow: 1,
				centerMode: true,
				centerPadding: '0',
				variableWidth: false,
				adaptiveHeight: false,
				arrows: false,
				dots: false,
				autoplay: true,
				autoplaySpeed: 4000
			});
			$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
				var $blocks = $(this).siblings(".progressStage__blocks").find(".progressStage__block")
				var $nextblock = $blocks.eq(nextSlide);
				activateProgressStageBlock($nextblock);				
			});

			activateProgressStageBlock($blocks.find(".progressStage__block").first());

			$blocks.find(".progressStage__block").on("click", function(){
				
				if(!$(this).hasClass("active")){
					
					var $progressStage = $(this).closest(".progressStage");
					$progressStage.attr("data-autoplay", "false");

					$(this).siblings(".progressStage__block").removeClass("active");
					var blockIndex = parseInt($(this).attr("data-index"));
					$slider.slick('slickGoTo', blockIndex);
					$slider.slick('slickPause');


					$(this).addClass("active");
				}
			});

			$(this).find(".progressStage__arrow--prev").on("click", function(){
				$slider.slick("slickPrev");
			});
			$(this).find(".progressStage__arrow--next").on("click", function(){
				$slider.slick("slickNext");
			});
			$(this).find(".progressStage__dot").on("click", function(){
				var dotIndex = $(this).attr("data-index");
				$slider.slick("slickGoTo", dotIndex);
			});

		});
	}

	updateProgressStage();
}

function updateProgressStage(){
	if($(".progressStage").length > 0){
		
		$(".progressStage").each(function(){

			//equalize block headline heights
			var blockHeadlineHeight = 0;
			var $blockHeadlines = $(this).find(".progressStage__block-headline");
			$blockHeadlines.css("height", "auto");
			$blockHeadlines.each(function(){
				if($(this).outerHeight() > blockHeadlineHeight){
					blockHeadlineHeight = Math.ceil($(this).outerHeight());
				}
			});

			if(blockHeadlineHeight > 0){
				$blockHeadlines.css("height", blockHeadlineHeight + "px");
			}

			//equalize block copy heights
			var blockCopyHeight = 0;
			var $blockCopies = $(this).find(".progressStage__block-copy");
			$blockCopies.css("height", "auto");
			$blockCopies.each(function(){
				if($(this).outerHeight() > blockCopyHeight){
					blockCopyHeight = Math.ceil($(this).outerHeight());
				}
			});

			if(blockCopyHeight > 0){
				$blockCopies.css("height", blockCopyHeight + "px");
			}
		});
	}
}

function activateProgressStageBlock($block){

	//console.log("activateProgressStageBlock() " + $block.attr("data-index"));
	
	var $progressStage = $block.closest(".progressStage");
	
	$block.siblings().removeClass("active");
	$block.siblings().find(".progressStage__block-progress").removeClass("state0");
	$block.siblings().find(".progressStage__block-progress").removeClass("state100");
	$block.siblings().find(".progressStage__block-progress").removeClass("animate100");
	
	//enable active block
	$block.addClass("active");
	$block.find(".progressStage__block-progress").removeClass("state0");
	$block.find(".progressStage__block-progress").removeClass("state100");
	$block.find(".progressStage__block-progress").removeClass("animate100");
	
	if($progressStage.attr("data-autoplay") == "true"){
		$block.find(".progressStage__block-progress").addClass("animate100");
	}
	else{
		$block.find(".progressStage__block-progress").addClass("state100");
	}

	$block.prevAll(".progressStage__block").find(".progressStage__block-progress").addClass("state100");
	$block.nextAll(".progressStage__block").find(".progressStage__block-progress").addClass("state0");

	//mobile dots
	var $dots = $progressStage.find(".progressStage__dot");
	$dots.removeClass("state0");
	$dots.removeClass("state100");
	$dots.removeClass("animate100");

	var dotIndex = $block.attr("data-index");
	var $activeDot = $dots.eq(dotIndex);
	$activeDot.addClass("animate100");
	$activeDot.prevAll(".progressStage__dot").addClass("state100");
	$activeDot.nextAll(".progressStage__dot").addClass("state0");
}
